"use client";

import { Avatar, resolveProfileImageSrc } from "./avatar";

interface UserAvatarCompatV2Props {
  user?: {
    id?: string | null;
    name?: string | null;
    lastname?: string | null;
    profileImage?: string | null;
    email?: string | null;
  } | null;
  size?: number;
  showName?: boolean;
  tooltip?: boolean;
  className?: string;
}

function sizeName(size?: number): "xs" | "sm" | "md" | "lg" | "xl" {
  if (!size) return "md";
  if (size <= 22) return "xs";
  if (size <= 32) return "sm";
  if (size <= 48) return "md";
  if (size <= 64) return "lg";
  return "xl";
}

export default function UserAvatarCompatV2({ user, size, showName }: UserAvatarCompatV2Props) {
  const name = [user?.name, user?.lastname].filter(Boolean).join(" ").trim() || user?.email || "Usuario";
  const src = resolveProfileImageSrc(user?.profileImage);

  return (
    <Avatar
      src={src}
      name={name}
      size={sizeName(size)}
      title={showName ? name : undefined}
      subtitle={showName ? user?.email : undefined}
    />
  );
}
